import React from 'react';

import styled from 'styled-components';

import { SalesPlaybookCategory } from 'types/recommendations';

import SalesPlaybookCard from './SalesPlaybookCard';

const SectionContainer = styled.div`
  padding: 30px;
  border-radius: 10px;
  border: solid 1px var(--line-gray);
  background-color: var(--background-gray-light);
`;

const SectionHeader = styled.div`
  display: flex;
  flex-flow: row;
  gap: 10px;
  align-items: center;
  font-size: 20px;
  font-family: var(--font-bold);
`;

const SectionIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 4px;
  line-height: 0;

  img {
    display: block;
    width: 20px;
    height: 20px;
  }

  &.lead-with {
    background-image: linear-gradient(to bottom, var(--mint-pale), var(--mint-soft));
  }

  &.position-against {
    background-image: linear-gradient(to bottom, var(--lavender-pale), var(--lavender-soft));
  }

  &.handle-objections {
    background-image: linear-gradient(to bottom, var(--gold-pale), var(--gold-soft));
  }
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 20px;

  @media (max-width: 1108px) {
    grid-template-columns: 1fr;
  }
`;

type Props = {
  id: string;
  variantClass: 'lead-with' | 'position-against' | 'handle-objections';
  iconSrc: string;
  title: string;
  categories: SalesPlaybookCategory[];
};

const SalesPlaybookSection = ({ id, variantClass, iconSrc, title, categories }: Props) => {
  return (
    <SectionContainer id={id}>
      <SectionHeader>
        <SectionIcon className={variantClass}>
          <img src={iconSrc} width="20" height="20" alt="" />
        </SectionIcon>
        {title}
      </SectionHeader>
      <CardGrid>
        {categories.map((cat) => (
          <SalesPlaybookCard key={cat.title} category={cat} />
        ))}
      </CardGrid>
    </SectionContainer>
  );
};

export default SalesPlaybookSection;
